var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-select',{ref:"baseSelectRef",attrs:{"isDefaultSelect":"","value":_vm.value,"resource":"serverskus","need-params":"","remote":"","idKey":"name","item":_vm.sku,"label-format":_vm.labelFormat,"mapper":_vm.mapper,"params":_vm.params},on:{"update:item":function($event){_vm.sku=$event},"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }